import { ajax } from '@/api/ajax';

export interface BrandSeriesModelListResp {
  /**
   * 品牌编码
   */
  brandList?: Brand[];
}
export interface Brand {
  /**
   * 品牌编码
   */
  brandCode?: string;
  /**
   * 品牌logo图片ID
   */
  brandLogoFileId?: string;
  /**
   * 品牌logo图片URL
   */
  brandLogoUrl?: string;
  /**
   * 品牌名称
   */
  brandName?: string;
  /**
   * 车系列表
   */
  seriesList?: Series[];
}
export interface Series {
  /**
   * 车型列表
   */
  modelList?: Model[];
  /**
   * 车系编码
   */
  seriesCode?: string;
  /**
   * 车系logo图片ID
   */
  seriesLogoFileId?: string;
  /**
   * 车系logo图片URL
   */
  seriesLogoUrl?: string;
  /**
   * 车系名称
   */
  seriesName?: string;
}
export interface Model {
  /**
   * 车型编码
   */
  modelCode?: string;
  /**
   * 车型名称
   */
  modelName?: string;
}

/**
 * @operationId brandSeriesModelListUsingPOST_1
 * @tags EPC目录查询
 * @logan http://logan-gateway.test.logan.xiaopeng.local/xp-ass-epc-cn-boot/doc.html#/EPC-%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/EPC%E7%9B%AE%E5%BD%95%E6%9F%A5%E8%AF%A2/brandSeriesModelListUsingPOST_1
 */
export function brandSeriesModelListUsingPost() {
  return ajax<BrandSeriesModelListResp>({
    url: '/api/tis/web/epc/catalog/brandSeriesModelList',
    method: 'post'
  });
}
